import * as React from "react";
import TableOfContents from "../../components/table-of-contents";
import { IMAGE_BASE_URL } from "../../data/baseURL";
import { businessModelMenu } from "../../data/business-submenu-data";
import { useScrollTop } from "../../hook/useScrollTop";
import { AboutDataContext } from "./about";

const BusinessModel = () => {
  const {
    about_businessmodel_banner,
    about_business_model_market_opportunity,
    about_business_operation,
    about_business_strategy,
  } = React.useContext(AboutDataContext);

  useScrollTop();

  return (
    <>
      <section className="d-none d-lg-block">
        <ul className="row fs-14 bg-light list-style-none text-center align-items-stretch gilroy-bold m-0 p-0">
          {businessModelMenu.map((menu) => (
            <li
              key={menu.label}
              className="col-4 d-block border-gray submenu-link d-flex justify-content-center align-items-center"
            >
              <a
                href={menu.link}
                className="text-decoration-none w-100 text-orange-ryb py-3 d-block"
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </section>
      <TableOfContents routes={businessModelMenu} />
      <section className="ms-35 me-35 mt-7">
        <section className="mt-5 pt-5">
          <img
            src={`${IMAGE_BASE_URL}/${about_businessmodel_banner?.image}`}
            loading="lazy"
            alt="business-model-banner"
            className="img-fluid d-block mx-auto"
          />
          <p
            className="fs-16 my-5 py-5"
            dangerouslySetInnerHTML={{
              __html: about_businessmodel_banner?.description,
            }}
          />
        </section>
        <section className="border-bottom mb-5" id="we-leverage-our-expertise">
          <h2 className="fs-30 gilroy-bold">
            Our strengths and market opportunities
          </h2>
          <div>
            {about_business_model_market_opportunity?.map((info) => (
              <section key={info?.id} className="row my-5 py-5">
                <div className="col-12 col-md-2 order-2 order-md-1">
                  <img
                    src={`${IMAGE_BASE_URL}/${info?.image}`}
                    loading="lazy"
                    alt={info?.id}
                    className="img-fluid d-block mb-5"
                  />
                </div>
                <div className="col-12 col-md-10 order-1 order-md-2">
                  <h3 className="fs-18 gilroy-bold">{info?.title}</h3>
                  <p
                    className="fs-16"
                    dangerouslySetInnerHTML={{ __html: info?.description }}
                  />
                </div>
              </section>
            ))}
          </div>
        </section>
        <section
          className="py-5 my-5 border-bottom"
          id="to-create-a-platform-for-growth"
        >
          <h2 className="fs-30 mb-5 gilroy-bold">Our operation platform</h2>
          <div className="my-5">
            {about_business_operation?.map((service, index) => (
              <div
                key={service?.id}
                className={`text-center ${
                  about_business_operation?.length === index + 1 ? "" : "pb-7"
                }`}
              >
                <h3 className="fs-18 gilroy-bold ">{service?.title}</h3>
                <img
                  src={`${IMAGE_BASE_URL}/${service?.image}`}
                  loading="lazy"
                  alt={service?.id}
                  className="img-fluid p-5 d-block mx-auto"
                />
              </div>
            ))}
          </div>
        </section>
        <section id="driven-by-our-sustainable-business-strategy">
          <h3
            className="fs-22 gilroy-bold py-5"
            dangerouslySetInnerHTML={{ __html: about_business_strategy?.title }}
          />
          <img
            src={`${IMAGE_BASE_URL}/${about_business_strategy?.image}`}
            loading="lazy"
            alt="strategyImg"
            className="img-fluid d-block mx-auto p-5"
          />
        </section>
      </section>
    </>
  );
};

export default BusinessModel;
